import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';
import { getUniqGeo } from './getUniqGeo';

export function addRegionalDistrictToJsonQuery(jsonQuery: TJsonQuery, id: number): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [{ id, type: 'regional_district_id' }];
  }

  const uniqRegionalDistricts = getUniqGeo(geo, [{ id, type: 'regional_district_id' }]);

  return geo.concat(uniqRegionalDistricts);
}
